const Loader = () => (
    <div
      id="loader"
      style={{
        display: "block",
      }}
    >
      <div className="fakeLoader" />
      <div id="scroller" className="scroller">
        <img src="page-loading.gif" alt="Loading..." />
      </div>
    </div>
  );

export default Loader;
